import { DateTime } from 'luxon'
import { connect } from 'react-redux'

const FlightModeList = ({ items }) => {

  console.log('FlightModeList', items)

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
        <span style={{ fontWeight: 'bold', minWidth: '180px', flexGrow: '1' }}>Local Time</span>
        <span style={{ fontWeight: 'bold', minWidth: '180px', flexGrow: '1' }}>TimeZone</span>
        <span style={{ fontWeight: 'bold', flexGrow: '1' }}>Duration</span>
      </div>
      {
        items.map((item, idx) => (<FlightListItem key={idx} item={item} />))
      }
    </div>
  )
}

const FlightListItem = ({ item }) => {
  console.log('FlightListItem', item)

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <span style={{ minWidth: '180px',flexGrow: '1' }}>{DateTime.fromISO(item.timestampLocal).toFormat('yyyy-LL-dd HH:mm')}</span>
      <span style={{ minWidth: '180px', flexGrow: '1' }}>{item.timeZone}</span>
      <span style={{ flexGrow: '1' }}>{item.durationMinutes}</span>
    </div>
  )
}

const state2Props = (state) => ({
  items: state.futureFlightModes
})

const dispatches = dispatch => ({})

export default connect(state2Props, dispatches)(FlightModeList)